import { render, staticRenderFns } from "./BFormInputLimited.vue?vue&type=template&id=38bfaba7&scoped=true&"
import script from "./BFormInputLimited.vue?vue&type=script&lang=js&"
export * from "./BFormInputLimited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bfaba7",
  null
  
)

export default component.exports